/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_ClassificationInputs */

const en_directory_submit_enrich_stage_classification = /** @type {(inputs: Directory_Submit_Enrich_Stage_ClassificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI classification`)
};

const zh_directory_submit_enrich_stage_classification = /** @type {(inputs: Directory_Submit_Enrich_Stage_ClassificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 分类`)
};

/**
* | output |
* | --- |
* | "AI classification" |
*
* @param {Directory_Submit_Enrich_Stage_ClassificationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_classification = /** @type {((inputs?: Directory_Submit_Enrich_Stage_ClassificationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_ClassificationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_classification(inputs)
	return zh_directory_submit_enrich_stage_classification(inputs)
});
export { directory_submit_enrich_stage_classification as "directory.submit.enrich.stage.classification" }